import {sharedThemeSettings} from "./sharedThemeSettings";

export const oneThemeSettings = {
  ...sharedThemeSettings,
  palette: {
    ...sharedThemeSettings.palette,
    mode: "light",
    primary: {
      light: "#e0e0e0",
      main: "#464646",
      dark: "#000000",
      soft: "#F5F5F5",
      bgColor: "#F5F5F5",
      pale: "#777e87",
      contrastText: "#fff"
    },
    secondary: {
      light: "#d8eeef",
      main: "#00A4B2",
      dark: "#076b74",
      soft: "#F5F5F5",
      pale: "#f5f5f9",
      contrastText: "#f5f5f9"
    },
    mainButton: {
      main: "#00A4B2",
      contrastText: "#fff"
    },
    mainButtonReverse: {
      main: "#fff",
      contrastText: "#00A4B2"
    },
    slider: {
      main: "#5247AF",
      contrastText: "#fff"
    },
    userBar: {
      background: "#000"
    },
  },
  typography: {
    fontFamily: '"Mont", sans-serif',
    h1: {
      fontSize: "48px",
      fontWeight: "bold",
      fontFamily: '"Mont", sans-serif'
    },
    h2: {
      fontSize: "36px",
      fontWeight: "bold",
      fontFamily: '"Mont", sans-serif'
    },
    h3: {
      fontSize: "24px",
      fontWeight: "bold",
      fontFamily: '"Mont", sans-serif'
    },
    h4: {
      fontSize: "20px",
      fontWeight: "bold",
      fontFamily: '"Mont", sans-serif'
    },
    h5: {
      fontFamily: '"Mont", sans-serif'
    },
    h6: {
      fontFamily: '"Mont", sans-serif'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '50px', // Legyen a gomb lekerekített
          '&.MuiButton-sizeLarge': { // Csak akkor legyen 19px, ha primary a szín
            fontSize: '19px',
            fontWeight: 'bold',
          },
        },
      }
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        rounded: {
          borderRadius: "16px",
          boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.16)',
        }
      }
    },
    muiTableProps: {
      PaperProps: {
        elevation: 0
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: "#00A4B2" //theme.palette.secondary.main,
          }
        }
      }
    }
  }
};